import { useEffect, useMemo, useRef, useState } from 'react'
import { Marker, useMap } from 'react-leaflet'
import { Z_INDEX } from '../../../../constants/properties'
import { useActions } from '../../../../hooks/redux/actions'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import { getMarkerIcon } from '../../../../utils/markers/getMarkerIcon'

export const NewEventMarker = () => {
  const map = useMap()
  const [position, setPosition] = useState(map.getCenter())
  const markerRef = useRef(null)
  const { setNewEventPosition } = useActions()
  const { showCreateNewEvent } = useSideBarControlls()

  useEffect(() => {
    setNewEventPosition(position)
    showCreateNewEvent()
  }, [setNewEventPosition, showCreateNewEvent, position])

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          // @ts-ignore
          setPosition(marker.getLatLng())
        }
      },
    }),
    []
  )

  return (
    <Marker
      draggable={true}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}
      icon={getMarkerIcon(true)}
      zIndexOffset={Z_INDEX.OFFSET_LOCATION_MARKER}
    />
  )
}
